import UsersDialog from "./UsersDialog";

const UsersPropertiesPanel = ({ formId, mode, uiSchema, userSchemaRequired, userSchemaOptional, userSchemaUpdate, saveUserData, formData, readOnly, handleFormChange }) => {

  const getSchema = (mode) => {
    if (mode === 'create') {
      return userSchemaRequired;
    } else if (mode === 'edit') {
      return userSchemaUpdate;
    } else {
      // in view mode should be readonly so just choose update schema. 
      // may want to create a view schema
      return userSchemaUpdate;
    }
  };

  return (
    <div>
      <UsersDialog formId={formId} schema={getSchema(mode)}
        uiSchema={uiSchema} saveData={saveUserData} formData={formData}
        handleFormChange={handleFormChange} readOnly={readOnly} />
    </div>
  );
}

export default UsersPropertiesPanel;